<template>
    <v-dialog persistent v-model="openingPeriodDialog" max-width="700px">
        <v-card>
            <v-card-title>
                <h2 style="font-size: 20px !important;" class="headline-title"
                    v-if="provider.opening_periods.length !== 0">
                    Attention : vos périodes et horaires d'ouverture sont inchangés
                </h2>
                <h2 style="font-size: 20px !important;" class="headline-title" v-else>
                    Attention : vous n'avez pas saisi de périodes et horaires d'ouverture
                </h2>
            </v-card-title>
            <v-card-text>
                <div v-if="provider.opening_periods.length !== 0">
                    Vos périodes et horaires d'ouverture n'ont pas été modifiés. Confirmez-vous qu'ils
                    sont valides ?
                </div>
                <div v-else>
                    Confirmez-vous que vous n'êtes pas ouvert selon certaines périodes et horaires ?
                </div>

                <v-spacer></v-spacer>

                <div class="d-flex justify-content-between mt-5">
                    <v-btn class="text-none" color="warning" outlined @click="scrollToOpeningPeriods"
                           v-if="provider.opening_periods.length !== 0">
                        Modifier mes périodes et horaires d'ouverture
                    </v-btn>
                    <v-btn class="text-none" color="warning" outlined @click="scrollToOpeningPeriods"
                           v-else>
                        Ajouter une période et horaires d'ouverture
                    </v-btn>

                    <v-btn class="text-none" color="success" outlined @click="confirmOpeningPeriods">
                        Je confirme
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapState, mapMutations} from "vuex"

export default {
    name: "OpeningPeriodModal",
    props: ['show'],
    methods: {
        ...mapMutations('web_form', ['setOpeningPeriodDialog', 'confirmOpeningPeriodDialog']),
        scrollToOpeningPeriods() {
            this.setOpeningPeriodDialog(false)

            this.$global.$emit('scroll-tab', 'opening-period-tab')
        },
        confirmOpeningPeriods() {
            this.confirmOpeningPeriodDialog()

            this.$global.$emit('trigger-save')
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'openingPeriodDialog'])
    }
}
</script>

